import React from "react";
import { Button, Modal } from "react-bootstrap";
const RejectWorkshopModal = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.show}
        onHide={() => {
          props.handleClose();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Reject Workshop: {props.workshop.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure, you want to reject this workshop?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              props.handleClose();
            }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            style={{
              position: "relative",
            }}
            onClick={() => {
              props.handleApprove(false);
              props.handleClose();
            }}
          >
            {" "}
            Reject
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default RejectWorkshopModal;
